import React, { useEffect, useState } from "react";
import DTOPromotionsARModal from "./DTOPromotionsARModal";
import PromotionsARModalPresenter from "./PromotionsARModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";
import { claimService } from "../../../../api/services/claimService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  promotions_data?: any;
  canAct: any;
  currentPromotionHistory?: any;
}

const PromotionsARModalController = ({
  isModalOpen,
  closeModal,
  promotions_data,
  canAct,
  currentPromotionHistory,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const [allActions, setAllActions] = useState([]);
  const { t } = useTranslation();
  const store_claimList: any = useAppSelector(
    (state) => state.claimListSlice.claimList
  );
  const userId = useAppSelector((state) => state.authSlice.user_id);

  const request_actionRequired = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOPromotionsARModal
        setAllActionsOfLeave={(actions: any) => setAllActions(actions)}
      />

      <PromotionsARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        promotions_data={promotions_data}
        canAct={canAct}
        currentPromotionHistory={currentPromotionHistory}
        allActions={allActions}
        userId={userId}
        handleSubmitAR_Request={request_actionRequired}
      />
    </div>
  );
};

export default PromotionsARModalController;
